
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

const configModule = namespace('config')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectBlocText extends Vue {
  @configModule.Action('getPropositionOptionsAction') getPropositionOptions: any
  @configModule.Action('getPropositionOptionByIdAction') getPropositionOptionById: any
  @configModule.Action('deletePropositionOptionAction') deletePropositionOption: any
  @configModule.Action('syncPropositionOptionAction') syncPropositionOption: any
  @configModule.Getter('propositionOptionsGetter') propositionOptions: any

  mounted() {
    this.getPropositionOptions()
  }

  changeOrder(data) {
    this.syncPropositionOption(data)
  }

  getLabelOptionForcee(value) {
    if (value) {
      return 'Oui'
    } else {
      return 'Non'
    }
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm("Confirmez vous la suppression de l'option ?", optionsVslim)
    if (ok) {
      this.deletePropositionOption(id).then(async () => {
        this.getPropositionOptions()
      })
    }
  }
}
